import { FormikProps } from "formik";
import { getFormikErrorMessage } from "../../utils/AppFunctions";
import { ICDropDown } from "../form/index";
import { cn } from "../../lib";

interface IOption {
  display_value: string;
  data_value: string | number;
}

interface ICustomFormikDropDown<T> extends FormikProps<T> {
  name: keyof T;
  placeholder: string;
  options: IOption[];
  containerFormikClassName?: string;
  searchable?: boolean;
  disabled?: boolean;
  defaultOption?: IOption;
  required?: boolean;
  onChange?: any;
}

const ICFormikDropDown = <T extends Object>(
  props: ICustomFormikDropDown<T>
) => {
  const { touched, errors, values, setFieldValue, onChange } = props;
  const {
    name,
    placeholder,
    containerFormikClassName,
    options,
    searchable,
    disabled,
    defaultOption,
    required,
  } = props;
  const fieldName = props.name as string;

  const handleSelect = (option: IOption) => {
    setFieldValue(fieldName, option.data_value);

    if (onChange) {
      onChange(option.data_value);
    }
  };

  return (
    <div
      className={cn({
        [`${containerFormikClassName}`]: containerFormikClassName,
      })}
    >
      <ICDropDown<string | number>
        options={options}
        selected={values[name] as string}
        onSelect={handleSelect}
        searchable={searchable}
        disabled={disabled}
        label={placeholder}
        errorMessage={
          touched[name] && errors[name]
            ? getFormikErrorMessage<T>(errors, touched, name)
            : undefined
        }
        defaultOption={defaultOption}
        required={required}
      />
    </div>
  );
};

export default ICFormikDropDown;
